/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from "classnames";
import { ChatMenu, ChatMenuProps } from "PFApp/components/chat/chat_menu";
import { ChatState } from "PFApp/components/chat/chat_states";
import { Conversation } from "PFTypes";
import { ProfileMinimized } from "PFTypes/profile";
import { Ref } from "react";

import css from "./chat.module.scss";
import { ChatHeaderActions } from "./chat_header_actions";
import { ChatHeaderTitle } from "./chat_header_title";
import { ChatMinimizedActions } from "./chat_minimized_actions";
import { getChatHeaderVisibility } from "./get_chat_header_visibility";

type ChatMenuPassthroughProps = Omit<ChatMenuProps, "conversation" | "targetUrl">;

type ChatHeaderInfo = {
  title: string;
  targetUrl: string | false;
  otherPerson: ProfileMinimized | null;
  isPrivate: boolean;
  flashTitle?: boolean;
  unreadCount: number;
};

type ChatHeaderWindowState = {
  selected: boolean;
  minimized: boolean;
  isBelow?: boolean;
  chatState: ChatState;
  expandable: boolean;
  expanded: boolean;
  dropdownOpen: boolean;
};

type ChatHeaderHandlers = {
  onHeaderClick: (event?: React.SyntheticEvent) => void;
  onMinimize: (event?: React.SyntheticEvent) => void;
  onExpand: (event?: React.SyntheticEvent) => void;
  onClose: (event?: React.SyntheticEvent) => void;
  onToggleDropdown: (open: boolean) => void;
};

type ChatHeaderProps = {
  conversation: Conversation;
  info: ChatHeaderInfo;
  windowState: ChatHeaderWindowState;
  handlers: ChatHeaderHandlers;
  dropdownFocusRef: Ref<HTMLAnchorElement>;
  chatMenuHandlers: ChatMenuPassthroughProps;
};

export const ChatHeader = ({
  conversation,
  info,
  windowState,
  handlers,
  dropdownFocusRef,
  chatMenuHandlers
}: ChatHeaderProps) => {
  const { title, targetUrl, otherPerson, isPrivate, flashTitle, unreadCount } = info;
  const { selected, minimized, isBelow, chatState, expandable, expanded, dropdownOpen } = windowState;
  const { onHeaderClick, onMinimize, onExpand, onClose, onToggleDropdown } = handlers;

  const { showMinimizedActions, showHeaderActions, showChatMenu } = getChatHeaderVisibility(
    selected,
    minimized,
    dropdownOpen
  );

  return (
    <div
      className={classNames(css.header, { [css.incognito]: isPrivate, [css.flashTitle]: flashTitle })}
      onClick={onHeaderClick}
      data-qa-id="chat-window-header"
    >
      <ChatHeaderTitle
        title={title}
        targetUrl={targetUrl}
        otherPerson={otherPerson}
        selected={selected}
        minimized={minimized}
        isBelow={isBelow}
      />
      {showMinimizedActions && <ChatMinimizedActions unreadCount={unreadCount} onClose={onClose} />}
      {showHeaderActions && (
        <ChatHeaderActions
          chatState={chatState}
          expandable={expandable}
          expanded={expanded}
          dropdownOpen={dropdownOpen}
          onMinimize={onMinimize}
          onExpand={onExpand}
          onClose={onClose}
          onToggleDropdown={onToggleDropdown}
        />
      )}

      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <a ref={dropdownFocusRef} tabIndex={0} className={css.dropdownFocus} />
      {showChatMenu && <ChatMenu conversation={conversation} targetUrl={targetUrl} {...chatMenuHandlers} />}
    </div>
  );
};
